module.exports = __webpack_public_path__ + "assets/img/more-info.558ab1ef.jpg";